import React, { useState ,useEffect} from "react";
import { useLocation } from "react-router-dom";

import Header from "../Header";
import Sidebar from "../Sidebar";
import {
  cameraicon,
  doctor,
  imagesend,
  menuicon16,
  profilebg,
  profileuser01,
} from "../imagepath";
import FeatherIcon from "feather-icons-react";
import { Link, useNavigate } from "react-router-dom";
import { use } from "react";


const HospitalProfile = () => {

      const [hospital, setHospital] = useState(); 
        const location = useLocation();


      useEffect(() => {
        const { hospital } = location.state || {}; // fallback in case state is missing
        console.log("hospital", hospital)
        setHospital(hospital);
        }, []);
    
  const  id  = hospital?.id;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    headerMargin: '',
    footerMargin: '', 
    leftMargin: '',
    rightMargin: ''
  });

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Here you would typically send the data to an API
  };

  // Handle cancel
  const handleCancel = () => {
    // Reset form or navigate away
    setFormData({
      headerMargin: '',
      footerMargin: '',
      leftMargin: '',
      rightMargin: ''
    });
    
    setActiveTab("profile");
  };


  const [activeTab, setActiveTab] = useState("profile");

  
    return (
      <div>
        <>
          <Header />
          <Sidebar activeClassName="hospital" />
          <>
            <div className="page-wrapper">
              <div className="content">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row">
                    <div className="col-sm-12">
                      <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/hospitalList">Hospital </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <i className="feather-chevron-right">
                            <FeatherIcon icon="chevron-right" />
                          </i>
                        </li>
                        <li className="breadcrumb-item active">
                          Hospital Profile
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="row">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="doctor-personals-grp">
                          <div className="card">
                            <div className="card-body">
                              
                              <div className="about-me-list">
                                <ul className="list-space">
                                  <li>
                                    <h4>Hospital Name.</h4>
                                    <span>{hospital?.Name}</span>
                                  </li>
                                  <li>
                                    <h4>Mobile no.</h4>
                                    <span>{hospital?.mobile}</span>
                                  </li>
                                  <li>
                                    <h4>Email</h4>
                                    <span>{hospital?.Email}</span>
                                  </li>
                                  <li>
                                    <h4>Status</h4>
                                    <span>Active</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="doctor-personals-grp">
                          <div className="card">
                            <div className="card-body">
                              <div className="tab-content-set">
                                <ul className="nav">
                                  <li>
                                    <Link
                                      to="#"
                                      className={
                                        activeTab === "profile" ? "active" : ""
                                      }
                                      onClick={() => setActiveTab("profile")}
                                    >
                                      <span className="set-about-icon me-2">
                                        <img src={doctor} alt="" />
                                      </span>
                                      About me
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to="#"
                                      className={
                                        activeTab === "setting" ? "active" : ""
                                      }
                                      onClick={() => setActiveTab("setting")}
                                    >
                                      <span className="set-about-icon me-2">
                                        <img src={menuicon16} alt="" />
                                      </span>
                                      Settings
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                              <div
                                id="profile"
                                style={{
                                  display:
                                    activeTab === "profile" ? "block" : "none",
                                }}
                              >
                                <div className="personal-list-out">
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="form-heading">
                                        <h4>BASIC DETAILS</h4>
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="detail-personal">
                                        <h2>Hospital Name</h2>
                                        <h3 className="pb-3">{hospital?.Name}</h3>
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="detail-personal">
                                        <h2>Mobile </h2>
                                        <h3>{hospital?.mobile}</h3>
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="detail-personal">
                                        <h2>Email</h2>
                                        <h3>{hospital?.Email}</h3>
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="detail-personal">
                                        <h2>Location</h2>
                                        <h3>{hospital?.address},{hospital?.city},{hospital?.state}</h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
                              </div>
                              <div
                                id="setting"
                                style={{
                                  display:
                                    activeTab === "setting" ? "block" : "none",
                                }}
                              >
                                <div className="setting-form-blk">
                                  <form onSubmit={handleSubmit}>
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="form-heading">
                                          <h4>Account Setting</h4>
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12">
                                        <div className="form-group local-forms">
                                          <label>Header Margin </label>
                                          <input
                                            className="form-control"
                                            type="number"
                                            name="headerMargin"
                                            value={formData.headerMargin}
                                            onChange={handleInputChange}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12">
                                        <div className="form-group local-forms">
                                          <label>Footer Margin </label>
                                          <input
                                            className="form-control"
                                            type="number"
                                            name="footerMargin"
                                            value={formData.footerMargin}
                                            onChange={handleInputChange}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12">
                                        <div className="form-group local-forms">
                                          <label className="">
                                            Left Margin{" "}
                                          </label>
                                          <input
                                            className="form-control"
                                            type="number"
                                            name="leftMargin"
                                            value={formData.leftMargin}
                                            onChange={handleInputChange}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-12 col-sm-12">
                                        <div className="form-group local-forms">
                                          <label>Right Margin </label>
                                          <input
                                            className="form-control"
                                            type="number"
                                            name="rightMargin"
                                            value={formData.rightMargin}
                                            onChange={handleInputChange}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-12">
                                      <div className="doctor-submit">
                                        <button
                                          type="submit"
                                          className="btn btn-primary submit-form me-2"
                                        >
                                          Save
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-primary cancel-form"
                                          onClick={handleCancel}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
            <div
              id="delete_patient"
              className="modal fade delete-modal"
              role="dialog"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-body text-center">
                    <img src={imagesend} alt="" width={50} height={46} />
                    <h3>Are you sure want to delete this ?</h3>
                    <div className="m-t-20">
                      {" "}
                      <Link
                        to="#"
                        className="btn btn-white me-2"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </Link>
                      <button type="submit" className="btn btn-danger">
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </>
      </div>
    );
}

export default HospitalProfile
